@for (element of _state; let index = $index; track $index) {
    <div
        class="lg-breadcrumb__element lg-breadcrumb__element--clickable"
        [class.lg-breadcrumb__element--active]="_activeIndex === index"
        #breadcrumb
        (click)="_showMenu($event, index, breadcrumb)"
        (keydown.enter)="_showMenu($any($event), index, breadcrumb)"
        tabindex="0"
    >
        <div class="lg-breadcrumb__arrow">
            <lg-icon icon="icon-arrow-down"></lg-icon>
        </div>
        <div class="lg-breadcrumb__element__text" [title]="element.name">
            {{ element.name }}
        </div>
    </div>
}
@if (_extraIndex != null) {
    <div
        class="lg-breadcrumb__element lg-breadcrumb__element--clickable lg-breadcrumb__element--hover-element"
        [class.breadcrumb-row__focusable-hover-element]="_activeIndex !== _extraIndex"
        [class.lg-breadcrumb__element--active]="_activeIndex === _extraIndex"
        #breadcrumb
        tabindex="0"
        (click)="_showMenu($event, _extraIndex, breadcrumb)"
        (keydown.enter)="_showMenu($any($event), _extraIndex, breadcrumb)"
    >
        <div class="lg-breadcrumb__arrow">
            <lg-icon icon="icon-arrow-down"></lg-icon>
        </div>
    </div>
}
